function updateProductTabsSliderButtons(sliderComponent) {
  const slider = sliderComponent.querySelector('[id^="Slider-"]');
  const prevButton = sliderComponent.querySelector('button[name="previous"]');
  const nextButton = sliderComponent.querySelector('button[name="next"]');

  if (!slider || !prevButton || !nextButton) return;

  const maxScroll = Math.max(0, slider.scrollWidth - slider.clientWidth);
  const atStart = slider.scrollLeft <= 2;
  const atEnd = slider.scrollLeft >= maxScroll - 2;

  if (atStart) {
    prevButton.setAttribute('disabled', 'disabled');
  } else {
    prevButton.removeAttribute('disabled');
  }

  if (atEnd || maxScroll <= 0) {
    nextButton.setAttribute('disabled', 'disabled');
  } else {
    nextButton.removeAttribute('disabled');
  }
}

function resetProductTabsSlider(sliderComponent) {
  const slider = sliderComponent.querySelector('[id^="Slider-"]');
  if (!slider) return;

  slider.scrollLeft = 0;

  if (typeof sliderComponent.resetPages === 'function') {
    sliderComponent.resetPages();
  }

  updateProductTabsSliderButtons(sliderComponent);
}

function initProductTabsSliders(root = document) {
  root.querySelectorAll('.product-tabs slider-component').forEach((sliderComponent) => {
    const slider = sliderComponent.querySelector('[id^="Slider-"]');
    if (!slider || sliderComponent.dataset.productTabsSliderInit === 'true') return;

    sliderComponent.dataset.productTabsSliderInit = 'true';
    slider.addEventListener('scroll', () => updateProductTabsSliderButtons(sliderComponent), { passive: true });

    if (!sliderComponent.closest('[hidden]')) {
      resetProductTabsSlider(sliderComponent);
    }
  });
}

class ProductTabsNav extends HTMLElement {
  constructor() {
    super();
    this.tabs = Array.from(this.querySelectorAll('.product-tabs__tab'));
    this.viewAllLink = this.closest('.product-tabs')?.querySelector('[data-product-tabs-view-all]');
    this.tabs.forEach((tab) => tab.addEventListener('click', this.onTabClick.bind(this)));
    initProductTabsSliders(this);
  }

  onTabClick(event) {
    const clickedTab = event.currentTarget;
    if (clickedTab.classList.contains('product-tabs__tab--active')) return;

    this.tabs.forEach((tab) => {
      const isActive = tab === clickedTab;
      tab.classList.toggle('product-tabs__tab--active', isActive);
      tab.setAttribute('aria-selected', isActive);

      const panel = document.getElementById(tab.getAttribute('data-tab-target'));
      if (!panel) return;

      panel.classList.toggle('product-tabs__panel--active', isActive);
      if (isActive) {
        panel.removeAttribute('hidden');
        requestAnimationFrame(() => {
          const sliderComponent = panel.querySelector('slider-component');
          if (sliderComponent) resetProductTabsSlider(sliderComponent);
          panel.querySelectorAll('card-slider').forEach((cardSlider) => {
            if (typeof cardSlider.connectedCallback === 'function') {
              cardSlider.connectedCallback();
            }
          });
        });
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    if (this.viewAllLink && clickedTab.dataset.collectionUrl) {
      this.viewAllLink.setAttribute('href', clickedTab.dataset.collectionUrl);
    }
  }
}

customElements.define('product-tabs-nav', ProductTabsNav);

document.addEventListener('DOMContentLoaded', () => initProductTabsSliders());
window.addEventListener('resize', () => {
  document.querySelectorAll('.product-tabs slider-component').forEach((sliderComponent) => {
    updateProductTabsSliderButtons(sliderComponent);
  });
});
